import React from 'react';

import { Button } from '../../../../../../base/components/Button';
import { Icon } from '../../../../../../base/components/Icon';

import './styles.scss';

interface Props {
    backLinkText: string;
    nextLinkText: string;
    progressWidth: number;
    onBackClick: () => void;
    onNextClick: () => void;
}

export const Footer = ({ backLinkText, nextLinkText, progressWidth, onBackClick, onNextClick }: Props) => {
    return (
        <div className='signup-footer'>
            <div className='app-progress-bar'>
                <span className='app-progress-bar__progress' style={{ width: `${progressWidth}%` }}></span>
            </div>
            <div className='signup-footer__buttons-wrap'>
                <Button className='signup-footer__button' type='link' onClick={onBackClick}>
                    {backLinkText}
                </Button>
                <Button className='signup-footer__button' onClick={onNextClick}>
                    {nextLinkText}
                    <Icon
                        className='signup-footer__button-icon'
                        icon='arrow-right-long-solid'
                        color='white'
                        size='15'
                    />
                </Button>
            </div>
        </div>
    );
};
